import { useEffect, useState } from "react";
import CodePreview from "../Code/CodePreview";
import { DescriptionDetails } from "../DescriptionList";
import { Tool } from "@/types/app/tool";
import { AttributeDetails } from "./AttributeDetails";

export const ToolVersionDetails = ({ tool }: { tool: Tool }) => {
  const [toolDefinition, setToolDefinition] = useState<string | null>(null);

  useEffect(() => {
    if (tool) {
      try {
        const definition = JSON.stringify(
          {
            name: tool?.function?.name,
            description: tool?.function?.description,
            parameters: tool?.function?.parameters,
          },
          null,
          2,
        );
        setToolDefinition(definition);
      } catch (e) {
        console.error("Failed to parse tool definition", e);
      }
    }
  }, [tool]);

  return (
    <>
      <dl className="flex h-full w-full flex-col items-start gap-y-40">
        {tool.function?.description && (
          <div className="flex flex-col gap-24">
            <div className="text-14-14 font-bold text-text-base-1">Description</div>
            <DescriptionDetails>{tool.function?.description}</DescriptionDetails>
          </div>
        )}

        {tool.type === "tool" && (
          <>
            {tool.source_code && (
              <div className="flex w-full flex-col gap-24">
                <div className="text-14-14 font-bold text-text-base-1">Source</div>
                <div className="rounded bg-oldgray-100 text-11-16">
                  <CodePreview language="python">{tool.source_code}</CodePreview>
                </div>
              </div>
            )}

            {toolDefinition !== null && (
              <div className="flex w-full flex-col gap-24">
                <div className="text-14-14 font-bold text-text-base-1">JSON Schema</div>
                <div className="max-h-480 w-full min-w-[300px] overflow-auto rounded-ms bg-background-base-1 p-12 text-12-16 shadow-card-sm">
                  <CodePreview showLineNumbers language="json">
                    {toolDefinition}
                  </CodePreview>
                </div>
              </div>
            )}
          </>
        )}
      </dl>
      <AttributeDetails {...tool} />
    </>
  );
};
